import { Button } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

export function MealCreditsAction(): JSX.Element {
  const { corpid } = useParams<{ corpid: string }>();
  const { push } = useHistory();
  const { isPhone } = useScreenSizes();

  return (
    <Button
      variant="secondary"
      buttonSize="medium"
      block={isPhone}
      onClick={() => {
        push(`/corporate/management/${corpid}/lineOfCredit`);
      }}
    >
      View meal credits
    </Button>
  );
}
